import { Component } from '@angular/core';

@Component({
  selector: 'app-editor-home-footer',
  templateUrl: 'footer.component.html'
})
export class HomeFooterComponent {
}

